import { render, staticRenderFns } from "./TopMenuItems.vue?vue&type=template&id=52bf6c51&scoped=true"
import script from "./TopMenuItems.vue?vue&type=script&lang=ts"
export * from "./TopMenuItems.vue?vue&type=script&lang=ts"
import style0 from "./TopMenuItems.vue?vue&type=style&index=0&id=52bf6c51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bf6c51",
  null
  
)

export default component.exports